var _path, _path2, _path3, _path4, _path5, _path6, _path7;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTariffSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.1394 5.0213H6.86035V29.8493H27.1394V5.0213Z",
    stroke: "#E2E8F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4247 14.7493H10.8057V26.3573H23.4247V14.7493Z",
    stroke: "#E2E8F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1152 14.7733V25.9003",
    stroke: "#E2E8F0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3253 18.2323H10.9043",
    stroke: "#E2E8F0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3253 21.5303H10.9043",
    stroke: "#E2E8F0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1699 8.9483H20.7929",
    stroke: "#E2E8F0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5947 11.3003H22.3667",
    stroke: "#E2E8F0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTariffSearch);
export default __webpack_public_path__ + "static/media/TariffSearch.cdaff920.svg";
export { ForwardRef as ReactComponent };